var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"platform-buttom-list"},[_c('div',{staticClass:"bottom-button m-r-5",on:{"click":_vm.goToIndex}},[_vm._v(" 项目管理 ")]),_c('div',{staticClass:"bottom-button-active"},[_vm._v(" 规则配置 ")])]),_c('div',[_c('RulesSettting',{attrs:{"projectId":_vm.id}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }